import { render, staticRenderFns } from "./Ocorrencias.vue?vue&type=template&id=0c0da076&scoped=true&"
import script from "./Ocorrencias.vue?vue&type=script&lang=ts&"
export * from "./Ocorrencias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0da076",
  null
  
)

export default component.exports